function urlHack(apiPrefix) {
  const { hostname, protocol } = window.location;
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL;
  }
  const com = hostname.split(".").slice(1).join(".");
  return `${protocol}//${apiPrefix}.${com}`;
}

export const urlDeterminer = (prefix = "nubis-api") => {
  return urlHack(prefix);
};

export const urlGoDeterminer = (prefix = "nubis-api") => {
  if (process.env.NODE_ENV === "development") {
    return "/apigo";
  }
  return urlHack(prefix);
};

export let url = urlDeterminer();

export let goUrl = urlGoDeterminer();

export const setUrlDeterminer = apiPrefix => {
  url = urlDeterminer(apiPrefix);
};

export const setGoUrlDeterminer = apiPrefix => {
  goUrl = urlGoDeterminer(apiPrefix);
};
